import { TrackingEvent } from '@transcend-io/segment/core';
import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import {
  SanityFormTrackingEventProperties,
  SanityHubspotConvertingFormType,
} from './form';
import { image, SanityImage } from './image';
import { link, SanityLink } from './link';

export const SanityFooter = z.object({
  newsletter: z.object({
    headline: z.string(),
    bodyCopy: z.string().optional().nullable(),
    emailInputPlaceholder: z.string(),
    submitButtonLabel: z.string(),
    legalText: SanityBasicText.optional().nullable(),
    trackingEventName: TrackingEvent,
    trackingEventProperties: SanityFormTrackingEventProperties,
    hubspotCampaignId: z.string().uuid().nullish(),
    hubspotConvertingFormType: SanityHubspotConvertingFormType,
    hubspotEmailSubscriptionIds: z.array(z.string()).nullish(),
    confirmation: z.string(),
  }),
  recaptchaNotice: SanityBasicText.optional().nullable(),
  linkGroups: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      links: z.array(SanityLink),
    }),
  ),
  secondaryLinks: z.array(SanityLink),
  copyrightText: z.string(),
  location: z.string(),
  socialLinks: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      icon: SanityImage,
      href: z.string(),
    }),
  ),
});
export type SanityFooter = z.infer<typeof SanityFooter>;

export const footer = groq`{
  newsletter {
    headline,
    bodyCopy,
    emailInputPlaceholder,
    submitButtonLabel,
    legalText[] ${basicText},
    trackingEventName,
    hubspotCampaignId,
    hubspotConvertingFormType,
    hubspotEmailSubscriptionIds,
    confirmation,
  },
  recaptchaNotice[] ${basicText},
  linkGroups[] {
    _key,
    title,
    links[] ${link},
  },
  secondaryLinks[] ${link},
  copyrightText,
  location,
  socialLinks[] {
    _key,
    title,
    'href': url,
    icon ${image},
  },
}`;
